import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public date:any="";
  constructor() { }

  ngOnInit() {

    var datel = new Date();
    this.date=moment(datel).format('LL');
    console.log(this.date);
  }

}
